import { Link } from "react-router-dom";

interface CrumbItem {
  label: string;
  to?: string;
}

export function Breadcrumb({ items }: { items: CrumbItem[] }) {
  return (
    <nav className="flex flex-wrap items-center gap-1 text-sm text-foreground-500" aria-label="面包屑">
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1">
          {index > 0 && <i className="ri-arrow-right-s-line text-foreground-300"></i>}
          {item.to ? (
            <Link to={item.to} className="cursor-pointer transition-colors hover:text-primary-600">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}